module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/41851407ad2e0c982425f2df0e0ff75a.png";